<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" v-loading="loading" :model="formData" :rules="rules" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="出库时间" prop="outboundTime">
              <el-date-picker v-model="formData.outboundTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择出库时间" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品名称" prop="productId">
              <el-select v-model="formData.productId" filterable clearable placeholder="请选择产品名称"
                @change="handleProductChange">
                <el-option v-for="item of productList" :key="item.productId" :label="item.productName"
                  :value="item.productId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品规格">
              <el-input v-model="productSpecName" disabled placeholder="选择产品后自动显示" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产单号" prop="recordNumber">
              <el-input v-model.trim="formData.recordNumber" placeholder="请输入生产单号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产日期" prop="productionDate">
              <el-date-picker v-model="formData.productionDate" type="date" value-format="yyyy-MM-dd"
                placeholder="请选择生产日期" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出库数量" prop="outboundQuantity">
              <el-input v-model.trim="formData.outboundQuantity" placeholder="请输入出库数量" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发货人" prop="shipperUserId">
              <el-select v-model="formData.shipperUserId" filterable clearable placeholder="请选择发货人">
                <el-option v-for="item of userList" :key="item.userId" :label="item.userName"
                  :value="item.userId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="领货人" prop="receiverUserId">
              <el-select v-model="formData.receiverUserId" filterable clearable placeholder="请选择领货人">
                <el-option v-for="item of userList" :key="item.userId" :label="item.userName"
                  :value="item.userId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" :loading="submitting" :disabled="loading || loadFailed" @click="submit" class="global-button">保存</el-button>
          <el-button v-if="loadFailed" @click="loadData" class="global-button">重新加载</el-button>
          <el-button :disabled="submitting" @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'FinishedGoodsOutboundAdd',
  data() {
    const validateQuantity = (rule, value, callback) => {
      if (!/^\d+(\.\d+)?$/.test(value) || !Number.isFinite(Number(value)) || Number(value) <= 0) {
        callback(new Error('出库数量必须为大于0的数字'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      loadFailed: false,
      submitting: false,
      productList: [],
      userList: [],
      productSpecName: '',
      formData: {
        outboundId: '', // 成品出库ID
        outboundTime: '', // 出库时间
        productId: '', // 产品名称
        recordNumber: '', // 生产单号
        productionDate: '', // 生产日期
        outboundQuantity: '', // 出库数量
        shipperUserId: '', // 发货人
        receiverUserId: '' // 领货人
      },
      rules: {
        outboundTime: [{ required: true, message: '请选择出库时间', trigger: 'change' }],
        productId: [{ required: true, message: '请选择产品名称', trigger: 'change' }],
        outboundQuantity: [{ required: true, validator: validateQuantity, trigger: 'blur' }],
        shipperUserId: [{ required: true, message: '请选择发货人', trigger: 'change' }],
        receiverUserId: [{ required: true, message: '请选择领货人', trigger: 'change' }]
      }
    }
  },
  computed: {
    outboundId() {
      return this.$route.query.outboundId
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.loadFailed = false
      const requests = [this.loadProductList(), this.loadUserList()]
      if (this.outboundId) {
        requests.push(this.loadDetails())
      }
      return Promise.all(requests).catch(() => {
        this.loadFailed = true
      }).finally(() => {
        this.loading = false
      })
    },
    loadProductList() {
      return this.$axios.get(this.$apis.prodManage.selectScProductByPage).then(res => {
        this.productList = res.list
      })
    },
    loadUserList() {
      return this.$axios.get(this.$apis.system.selectSysUserByPage).then(res => {
        this.userList = res.list
      })
    },
    handleProductChange(productId) {
      const product = this.productList.find(item => item.productId === productId)
      this.productSpecName = product ? product.specName : ''
    },
    loadDetails() {
      return this.$axios.get(this.$apis.prodManage.selectScFinishedGoodsOutboundById, {
        params: { outboundId: this.outboundId }
      }).then(res => {
        Object.keys(this.formData).forEach(key => {
          this.formData[key] = res[key] == null ? '' : res[key]
        })
        this.formData.outboundTime = res.outboundTime ? dayjs(res.outboundTime).format('YYYY-MM-DD HH:mm:ss') : ''
        this.formData.productionDate = res.productionDate ? dayjs(res.productionDate).format('YYYY-MM-DD') : ''
        this.productSpecName = res.productSpecName || ''
      })
    },
    submit() {
      if (this.loading || this.loadFailed || this.submitting) {
        return
      }
      this.$refs.formData.validate(valid => {
        if (!valid || this.submitting) {
          return
        }
        this.submitting = true
        let url = this.$apis.prodManage.insertScFinishedGoodsOutbound
        if (this.outboundId) {
          url = this.$apis.prodManage.updateScFinishedGoodsOutbound
        }
        this.$axios.post(url, {
          ...this.formData,
          outboundId: this.outboundId,
          productionDate: this.formData.productionDate || null
        }).then(() => {
          this.$router.back()
        }).catch(() => {
          // 请求错误由全局拦截器提示，保留表单供修改后重试。
        }).finally(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-select,
.el-input,
.el-date-editor,
.el-textarea {
  width: 95%;
}
</style>
